<template>
    <v-container class="pt-0" fluid>
        <v-card class="px-5 py-3 br-15 w-100" elevation="0">
            <v-row>
                <v-col class="flex-grow-1">
                    <v-toolbar-title class="page-title"
                        >Negociação comercial</v-toolbar-title
                    >
                </v-col>
                <v-col cols="2">
                    <v-tooltip top :disabled="!travaInventario">
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                <v-btn
                                    class="new-button w-100"
                                    color="primary"
                                    :disabled="travaInventario"
                                    @click="$refs.formulario.novo(usuarioTipo)"
                                    v-if="['rd'].includes(usuarioTipo)"
                                >
                                    <v-icon left>mdi-plus-thick</v-icon> Criar
                                    acordo
                                </v-btn>
                            </div>
                        </template>
                        <span
                            >Criação de acordo desabilitada até a finalização da
                            aprovação do inventário.</span
                        >
                    </v-tooltip>
                </v-col>
                <v-col cols="2" v-if="['rd'].includes(usuarioTipo) && fnGerarAcordosAutomaticos">                    <v-btn
                        class="new-button w-100"
                        color="primary"
                        :disabled="travaInventario || carregando"
                        @click="abrirPreviewGerarAcordos"
                        
                    >
                        <v-icon left>mdi-auto-fix</v-icon>
                        Gerar acordos
                    </v-btn>
                </v-col>
                <v-col cols="2">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="primary"
                                class="new-button w-100"
                                dark
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon left>mdi-microsoft-excel</v-icon>
                                Exportar
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="exportar()">
                                <v-list-item-title
                                    >Exportação Acordos</v-list-item-title
                                >
                            </v-list-item>
                            <v-list-item @click="exportar('produtos')">
                                <v-list-item-title
                                    >Exportação Produtos</v-list-item-title
                                >
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
            <filtro ref="filtro" @filtrar="filtrar" @limpar="limpar"></filtro>
        </v-card>
        <indicadores
            v-if="usuarioTipo == 'rd'"
            ref="indicadores"
            :indicadores="indicadores"
            :filtro="$refs.filtro"
        ></indicadores>

        <v-card elevation="0" class="br-15 pa-5 involucroAcordo">
            <v-data-table
                v-model="acordoSelecionado"
                :headers="headers"
                :items="acordos"
                :server-items-length="totalAcordos"
                item-key="id_negociacao_comercial"
                show-select
                fixed-header
                multi-sort
                :items-per-page="5"
                :footer-props="{
                    'items-per-page-options': [5, 10, 15, 25, 50, 100, 500, -1],
                    itemsPerPageText: 'Linhas por páginas',
                    ofText: 'de',
                    pageText: '{0}-{1} de {2}',
                }"
                :options.sync="pagination"
                class="tabela paginacao-esquerda flex-table"
            >
            <template v-slot:[`item.investimento`]="{ item }">
                <formataReal :valor="item.investimento" />
            </template>
                     <template v-slot:[`item.valor`]="{ item }">
                <formataReal :valor="item.valor" />
            </template>
                     <template v-slot:[`item.desconto`]="{ item }">
                <formataReal :valor="item.desconto" />
            </template>
                <template
                    v-slot:[`item.data-table-select`]="{
                        item,
                        isSelected,
                        select,
                    }"
                >
                    <v-simple-checkbox
                        :ripple="false"
                        :value="isSelected"
                        color="primary"
                        :disabled="
                            (!fnLiberar &&
                                !statusAcesso(
                                    item.id_status,
                                    'aprovar_reprovar'
                                )) ||
                            (fnLiberar &&
                                (!statusAcesso(item.id_status, 'liberar') ||
                                    item.mes_acordo != mesAtual))
                        "
                        :off-icon="
                            (!fnLiberar &&
                                !statusAcesso(
                                    item.id_status,
                                    'aprovar_reprovar'
                                )) ||
                            (fnLiberar &&
                                (!statusAcesso(item.id_status, 'liberar') ||
                                    item.mes_acordo != mesAtual))
                                ? '$checkboxLocked'
                                : 'mdi-checkbox-blank-outline'
                        "
                        :on-icon="
                            (!fnLiberar &&
                                !statusAcesso(
                                    item.id_status,
                                    'aprovar_reprovar'
                                )) ||
                            (fnLiberar &&
                                (!statusAcesso(item.id_status, 'liberar') ||
                                    item.mes_acordo != mesAtual))
                                ? '$checkboxLocked'
                                : 'mdi-checkbox-marked'
                        "
                        @input="select($event)"
                    ></v-simple-checkbox>
                  
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-menu
                        offset-y
                        min-width="180"
                        content-class=" acordo-menu"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                dark
                                color="#f2f2f2"
                                v-bind="attrs"
                                v-on="on"
                                small
                                class="px-1"
                                style="min-width: unset"
                            >
                                <v-icon color="#CCC">mdi-menu</v-icon>
                            </v-btn>
                        </template>
                        <v-card>
                            <v-list dense nav>
                                <v-list-item
                                    v-if="
                                        statusAcesso(
                                            item.id_status,
                                            'aprovar_reprovar'
                                        ) &&
                                        fnAprovar &&
                                        usuarioTipo == 'rd'
                                    "
                                    link
                                    @click="$refs.dialogo.reprovar(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="grey lighten-1"
                                            >$documentRemove</v-icon
                                        >
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            >Reprovar Acordo</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    v-if="
                                        statusAcesso(
                                            item.id_status,
                                            'aprovar_reprovar'
                                        ) &&
                                        fnAprovar &&
                                        usuarioTipo == 'rd'
                                    "
                                    link
                                    @click="$refs.dialogo.aprovar(item)"
                                    class="hover-red"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="grey lighten-1"
                                            >$documentCheck</v-icon
                                        >
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            >Aprovar Acordo</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    v-if="
                                        (item.mes_acordo > mesAtual &&
                                        statusAcesso(
                                            item.id_status,
                                            'editar'
                                        ) &&
                                        usuarioTipo == 'rd') || 
                                        item.is_automatico
                                    "
                                    link
                                    @click="$refs.formulario.editar(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-pencil</v-icon
                                        >
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            >Editar Acordo</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    class="pl-2 mr-0"
                                    v-if="['rd', 'cubo'].includes(usuarioTipo)"
                                    link
                                    @click="$refs.dialogo.historico(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-file-document-outline</v-icon
                                        >
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            >Histórico</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    link
                                    @click="$refs.formulario.editar(item, true)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-file-document-edit</v-icon
                                        >
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            >Exibir Acordo</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    v-if="
                                        item.termino == item.mes_acordo &&
                                        item.termino >= mesAnterior &&
                                        statusAcesso(
                                            item.id_status,
                                            'renovar'
                                        ) &&
                                        usuarioTipo == 'rd'
                                    "
                                    link
                                    @click="$refs.dialogo.renovacao(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-update</v-icon
                                        >
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            >Renovar Acordo</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="!travaInventario && (item.mes_acordo >= mesAtual &&
                                    statusAcesso(
                                        item.id_status,
                                        'replicar_cancelado'
                                    ) &&
                                    usuarioTipo == 'rd')
                                    " link @click="
                                        $refs.formulario.replicarAcordo(
                                            item,
                                            'cancelado'
                                        )
                                        ">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-autorenew</v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                        <v-list-item-title>Replicar
                                            Cancelado</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    v-if="
                                        item.obs_departamento &&
                                        usuarioTipo == 'rd'
                                    "
                                    link
                                    @click="
                                        $refs.dialogo.dialogDepartamento(item)
                                    "
                                >
                                    <v-list-item-icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-clipboard-text-outline</v-icon
                                        >
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            >Obs.
                                            Departamento</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    v-if="item.obs_contrato"
                                    link
                                    @click="$refs.dialogo.dialogContrato(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="grey lighten-1"
                                            >mdi-clipboard-text</v-icon
                                        >
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            >Obs. Contrato</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    v-if="
                                        statusAcesso(
                                            item.id_status,
                                            'cancelar'
                                        ) && usuarioTipo == 'rd'
                                    "
                                    link
                                    @click="$refs.dialogo.cancelar(item)"
                                    class="hover-red"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="grey lighten-1"
                                            >$documentRemove</v-icon
                                        >
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            >Cancelar Acordo</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    v-if="
                                        fnLiberar &&
                                        statusAcesso(
                                            item.id_status,
                                            'liberar'
                                        ) &&
                                        item.mes_acordo == mesAtual &&
                                        usuarioTipo == 'rd'
                                    "
                                    link
                                    @click="dialogoLiberarAcordos(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="grey lighten-1"
                                            >$documentCheck</v-icon
                                        >
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            >Liberar Acordo</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-menu>
                </template>
            </v-data-table>
            <div
                v-if="usuarioTipo == 'rd'"
                class="table-footer-prepend d-flex pl-2 pt-4 align-center justify-end"
            >
                <v-btn
                    v-if="!fnLiberar"
                    class="new-button ml-5"
                    :disabled="
                        !acordoSelecionado.filter((e) =>
                            statusAcesso(e.id_status, 'aprovar_reprovar')
                        ).length || !fnAprovar
                    "
                    color="primary"
                    @click="$refs.dialogo.aprovar()"
                >
                    <v-icon left>mdi-check-circle</v-icon> Aprovar Acordos
                </v-btn>
                <v-btn
                    class="new-button ml-5"
                    v-if="!fnLiberar"
                    :disabled="
                        !acordoSelecionado.filter((e) =>
                            statusAcesso(e.id_status, 'aprovar_reprovar')
                        ).length || !fnAprovar
                    "
                    color="error"
                    @click="$refs.dialogo.reprovar()"
                >
                    <v-icon left>mdi-close-circle</v-icon> Reprovar Acordos
                </v-btn>
                <v-btn
                    v-if="fnLiberar"
                    class="new-button ml-5"
                    :disabled="
                        !acordoSelecionado.filter(
                            (e) =>
                                statusAcesso(e.id_status, 'liberar') &&
                                e.mes_acordo == mesAtual &&
                                usuarioTipo == 'rd'
                        ).length
                    "
                    color="primary"
                    @click="dialogoLiberarAcordos()"
                >
                    <v-icon left>mdi-check</v-icon> Liberar acordos
                </v-btn>
            </div>
        </v-card>
        <dialogo
            ref="dialogo"
            @aprovarAcordo="aprovarAcordo"
            @liberarAcordo="liberarAcordo"
            @filtrar="filtrar"
            @renovar="renovar"
        ></dialogo>

        <formulario ref="formulario" @filtrar="filtrar"></formulario>

        <v-overlay :value="carregando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar
            v-model="alerta"
            :color="alertaColor"
            :timeout="alertaTimeout"
            top
            style="z-index: 400"
        >
            <v-alert :type="alertaColor">
                {{ alertaTexto }}
            </v-alert>
            <v-btn dark text class="float-right" @click="alerta = false">
                Fechar
            </v-btn>
        </v-snackbar>

        <!-- Dialog de Progresso -->
        <v-dialog
            v-model="dialogProgresso"
            persistent
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline">
                    Gerando Acordos Automáticos
                </v-card-title>
                <v-card-text>
                    <div class="mb-4">
                        {{ progressoMensagem }}
                    </div>
                    <v-progress-linear
                        v-if="!progressoFinalizado"
                        :value="progressoPorcentagem"
                        color="primary"
                        height="25"
                        striped
                    >
                        <template v-slot:default="{ value }">
                            <strong>{{ Math.ceil(value) }}%</strong>
                        </template>
                    </v-progress-linear>
                    <v-alert
                        v-if="progressoFinalizado"
                        :type="progressoSucesso ? 'success' : 'error'"
                        class="mt-3"
                    >
                        {{ progressoMensagemFinal }}
                    </v-alert>
                </v-card-text>
                <v-card-actions v-if="progressoFinalizado">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="fecharDialogProgresso"
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog de Confirmação -->
        <v-dialog content-class="br-15" v-model="dialogConfirmacaoGerarAcordos" width="700" persistent>
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary-degrade white--text fix-flex"
                >
                    <v-toolbar-title>Confirmar Geração de Acordos</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        :disabled="carregandoPreview"
                        @click="dialogConfirmacaoGerarAcordos = false"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <!-- Estado: carregando -->
                <v-card-text v-if="carregandoPreview" class="d-flex flex-column align-center justify-center py-10">
                    <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                    <span class="mt-4 body-2 grey--text text--darken-1">Carregando preview dos acordos...</span>
                </v-card-text>

                <!-- Estado: erro -->
                <v-card-text v-else-if="previewDados && previewDados.success === false" class="mt-4">
                    <v-alert type="error" outlined>
                        <strong>Erro ao carregar preview:</strong> {{ previewDados.message }}
                        <br>
                        <span class="body-2">Você ainda pode confirmar a geração dos acordos.</span>
                    </v-alert>
                </v-card-text>

                <!-- Estado: dados carregados -->
                <v-card-text v-else-if="previewDados" class="mt-4 px-5">
                    <!-- Orientação -->
                    <v-alert colored-border class="mb-4">
                        <strong>Orientação:</strong> Foi alterado na área administrativa os fornecedores que não devem ser gerados os acordos em negociação comercial?
                        <br><br>
                        Caso não, favor cancelar e fazer esse procedimento antes de gerar os acordos automáticos. Se estiver tudo correto, favor clicar em confirmar.
                    </v-alert>

                    <!-- Cards de resumo -->
                    <v-row class="mb-3" dense>
                        <v-col cols="4">
                            <v-card outlined class="pa-3 text-center br-10">
                                <div class="overline grey--text text--darken-1 mb-1">Acordos previstos</div>
                                <div class="text-h5 font-weight-bold primary--text">{{ previewDados.acordosPrevistos.length }}</div>
                            </v-card>
                        </v-col>
                        <v-col cols="4">
                            <v-card outlined class="pa-3 text-center br-10" :class="previewDados.acordosAusentes.length > 0 ? 'warning--border' : ''">
                                <div class="overline grey--text text--darken-1 mb-1">Ausentes (sem PDV)</div>
                                <div class="text-h5 font-weight-bold" :class="previewDados.acordosAusentes.length > 0 ? 'warning--text' : 'success--text'">
                                    {{ previewDados.acordosAusentes.length }}
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="4">
                            <v-card outlined class="pa-3 text-center br-10">
                                <div class="overline grey--text text--darken-1 mb-1">Sem neogrupo</div>
                                <div class="text-h5 font-weight-bold" :class="previewDados.fornecedoresSemNeogrupo.length > 0 ? 'warning--text' : 'success--text'">
                                    {{ previewDados.fornecedoresSemNeogrupo.length }}
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>

                    <!-- Alerta: acordos ausentes -->
                    <v-alert
                        v-if="previewDados.acordosAusentes.length > 0"
                        type="warning"
                        outlined
                        class="mb-3"
                    >
                        <div class="d-flex align-start justify-space-between">
                            <div>
                                <p class="mb-0">Os seguintes fornecedores possuem percentuais de neogrupo cadastrados, porém <strong>não possuem produtos PDV</strong> no neogrupo/bandeira correspondente, impedindo a geração automática do acordo.</p>
                            </div>
                            <v-btn
                                text
                                small
                                color="warning"
                                class="ml-2 flex-shrink-0"
                                @click="abrirDetalhePreview('acordosAusentes')"
                            >
                                <v-icon left small>mdi-eye</v-icon>
                                Ver detalhes
                            </v-btn>
                        </div>
                    </v-alert>

                    <!-- Alerta: fornecedores sem neogrupo -->
                    <v-alert
                        v-if="previewDados.fornecedoresSemNeogrupo.length > 0"
                        type="warning"
                        outlined
                        class="mb-3"
                    >
                        <div class="d-flex align-start justify-space-between">
                            <div>
                                <p class="mb-0">Os seguintes fornecedores possuem acordos no PDV mas <strong>não geraram acordos em negociação comercial</strong> pois não possuem os percentuais de neogrupo (OTC/Perfumaria/RX) cadastrados.</p>
                            </div>
                            <v-btn
                                text
                                small
                                color="warning"
                                class="ml-2 flex-shrink-0"
                                @click="abrirDetalhePreview('fornecedoresSemNeogrupo')"
                            >
                                <v-icon left small>mdi-eye</v-icon>
                                Ver detalhes
                            </v-btn>
                        </div>
                    </v-alert>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="new-button ml-auto mb-2 mr-2 px-3"
                        color="error"
                        :disabled="carregandoPreview"
                        @click="dialogConfirmacaoGerarAcordos = false"
                    >
                        <v-icon class="mr-3">mdi-close-circle</v-icon>
                        Cancelar
                    </v-btn>
                    <v-btn
                        class="new-button mb-2 px-3"
                        color="primary"
                        :disabled="carregandoPreview"
                        @click="confirmarGerarAcordos"
                    >
                        <v-icon class="mr-3">mdi-check-circle</v-icon>
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog de detalhe do preview -->
        <v-dialog content-class="br-15" v-model="dialogPreviewDetalhe" width="900">
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary white--text fix-flex"
                >
                    <v-toolbar-title>{{ previewDetalheConfig.titulo }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogPreviewDetalhe = false"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="mt-4">
                    <v-data-table
                        :headers="previewDetalheConfig.headers"
                        :items="previewDetalheConfig.dados"
                        :items-per-page="10"
                        class="elevation-1"
                    >
                        <template v-slot:[`item.total_investimento`]="{ item }">
                            {{ formatarMoedaPreview(item.total_investimento) }}
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions>
                    <download-csv
                        :data="previewDetalheConfig.dados"
                        :labels="previewDetalheConfig.labels"
                        :name="previewDetalheConfig.nomeArquivo"
                        delimiter=";"
                    >
                        <v-btn color="primary">
                            <v-icon left>mdi-microsoft-excel</v-icon>
                            Exportar
                        </v-btn>
                    </download-csv>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="new-button mb-2 mr-2 px-3"
                        color="primary"
                        @click="dialogPreviewDetalhe = false"
                    >
                        <v-icon class="mr-3">mdi-close</v-icon>
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import useFiltros from '../../../hooks/useFiltros'
import Indicadores from './_components/Indicadores.vue'
import Formulario from './formulario/formulario.vue'
import Filtro from './Filtro.vue'
import Dialogo from './Dialogo.vue'

export default {
    setup() {
        const { isLoading, isError, isFetching, lista, error, refetch } =
            useFiltros('/negociacaoComercial/listaCampos')

        return { isLoading, isError, isFetching, lista, error, refetch }
    },
    components: {
        Indicadores,
        Formulario,
        Filtro,
        Dialogo,
    },
    data() {
        return {
            usuarioTipo: 'rd',
            acordoSelecionado: [],
            acordos: [],
            totalAcordos: 0,
            indicadores: {},
            carregando: false,
            alerta: false,
            alertaTexto: '',
            alertaColor: 'error',
            alertaTimeout: 3000,
            status: [],
            fnAprovar: false,
            fnLiberar: false,
            fnGerarAcordosAutomaticos: false,
            pagination: {
                // sortBy: ['id_negociacao_comercial'],
                sortDesc: [true],
            },
            dialogProgresso: false,
            progressoPorcentagem: 0,
            progressoMensagem: '',
            progressoFinalizado: false,
            progressoSucesso: false,
            progressoMensagemFinal: '',
            dialogConfirmacaoGerarAcordos: false,
            carregandoPreview: false,
            previewDados: null,
            dialogPreviewDetalhe: false,
            previewDetalheConfig: {
                titulo: '',
                dados: [],
                labels: {},
                headers: [],
                nomeArquivo: '',
            },
        }
    },
    provide() {
        return {
            listaCampos: this.listaCampos(),
            usuarioTipo: this.usuarioTipo,
        }
    },
    computed: {
        travaInventario() {
            let a = 1
            if (1 == a) {
                return false
            }
            if (this.lista.inventarioUltimoHistorico) {
                return this.lista.inventarioUltimoHistorico.importacaoAndamento
            }
            return true
        },
        mesAtual() {
            return this.$moment().format('YYYY-MM')
        },
        mesAnterior() {
            return this.$moment().subtract(1, 'months').format('YYYY-MM')
        },
        mesProximo() {
            return this.$moment().add(1, 'months').format('YYYY-MM')
        },

        headers: () => [
            {
                text: 'Menu',
                value: 'actions',
                sortable: false,
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'Tipo de Acordo',
                value: 'tipo_acordo',
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'Acordo',
                value: 'id_negociacao_comercial',
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'ID integração',
                value: 'id_integracao',
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'Acordo RD',
                value: 'acordo_rd',
                align: 'center',
                class: 'th-separador   ',
            },

            {
                text: 'Fornecedor',
                value: 'fornecedor',
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'Espaço',
                value: 'espaco',
                align: 'center',
                class: 'th-separador   ',
            },

            {
                text: 'Bandeira',
                value: 'bandeira',
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'Mês',
                value: 'mes',
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'Ano',
                value: 'ano',
                align: 'center',
                class: 'th-separador   ',
            },

            {
                text: 'Contrato',
                value: 'id_contrato_negociacao',
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'Contrato RD',
                value: 'contrato',
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'Parcela',
                value: 'parcela',
                sortable: false,
                align: 'center',
                class: 'th-separador   ',
            },

            {
                text: 'Status',
                value: 'status',
                align: 'center',
                class: 'th-separador   ',
            },

            {
                text: 'Just. Reprov.',
                value: 'justificativa_reprovacao',
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'Just. Cancel.',
                value: 'justificativa_cancelamento',
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'Produtos',
                value: 'produtos',
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'Prod. Edit.',
                value: 'produtos_alterados',
                align: 'center',
                class: 'th-separador   ',
            },
          {
                text: 'Valor',
                value: 'valor',
                align: 'center',
                class: 'th-separador   ',
            },          {
                text: 'Desconto',
                value: 'desconto',
                align: 'center',
                class: 'th-separador   ',
            },          {
                text: 'Investimento',
                value: 'investimento',
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'Justificativa Desconto',
                value: 'justificativa',
                align: 'center',
                class: 'th-separador   ',
            },

            {
                text: 'Usuário que Criou',
                value: 'usuario_criacao',
                sortable: true,
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'Cód. Fornecedor',
                value: 'codigo',
                align: 'center',
                class: 'th-separador   ',
            },
            {
                text: 'IDs Acordo PDV',
                value: 'ids_pdv',
                align: 'center',
                class: 'th-separador   ',
            },
        ],
    },

    async beforeCreate() {
        const response = await this.$http().post('/acordo/status', {})

        this.status = response.data

        const response2 = await this.$http().post('/acordo/permissao', {
            id_menu: 2,
        })

        this.fnAprovar = response2.data


        const response3 = await this.$http().post('/acordo/permissao', {
            id_menu: 110,
        })
        console.log(response3.data)
        if(response3.data && response3.data == true) {
            this.fnGerarAcordosAutomaticos = true
        }
    },

    watch: {
        pagination: {
            handler() {
                this.filtrar(false)
            },
            deep: true,
        },
    },
    methods: {
        async listaCampos() {
            var response = await this.$http().post(
                '/negociacaoComercial/listaCampos',
                {}
            )

            return response.data
        },
        limpar() {
            this.statusIndicadores = []

            this.filtrar()
        },

        statusAcesso(id_status, acesso) {
            if (this.status) {
                if (id_status === 30 && acesso === 'editar_planograma')
                    return false

                var status = this.status.find((e) => e.id_status == id_status)

                return status[acesso]
            } else {
                return false
            }
        },
        async filtrar(paginaInicial = true) {
            if (!this.$refs.filtro.validate()) return

            this.carregando = true

            this.acordoSelecionado = []

            const filtro = this.$refs.filtro.filtro
            const data = {}

            data.mesInicial = filtro.mesInicial

            data.mesFinal = filtro.mesFinal

            data.tipoPeriodo = filtro.tipoPeriodo ? filtro.tipoPeriodo : -1

            data.bandeira = filtro.bandeira
            data.id_espaco = filtro.id_espaco
            data.id_fornecedor = filtro.id_fornecedor
            data.id_status = filtro.id_status ? filtro.id_status : []
            data.id_negociacao_comercial = filtro.id_negociacao_comercial
                ? [filtro.id_negociacao_comercial]
                : []
            data.acordo_rd = filtro.acordo_rd ? [filtro.acordo_rd] : []
            data.id_usuario_criacao = filtro.id_usuario_criacao
                ? filtro.id_usuario_criacao
                : []
            data.id_contrato = filtro.id_contrato ? [filtro.id_contrato] : []
            data.contrato = filtro.contrato ? [filtro.contrato] : []
            data.id_macrofornecedor = filtro.id_macrofornecedor ? filtro.id_macrofornecedor : [];
            data.id_usuario_criacao = filtro.id_usuario_criacao ? filtro.id_usuario_criacao : [];

            if (
                data.id_status.length > 0 &&
                data.id_status.every((status) => status === 29)
            ) {
                // console.log(data.id_status)
                this.fnLiberar =
                    true &&
                    [1, 2].includes(this.$store.getters.getUsuario.id_cargo)
            } else {
                this.fnLiberar = false
            }

            if (paginaInicial) this.pagination.page = 1

            data.pagination = this.pagination

            var response = await this.$http().post(
                '/negociacaoComercial/lista',
                {
                    data: data,
                }
            )

            this.acordos = response.data.lista
            this.totalAcordos = response.data.total
            this.indicadores = response.data.indicadores

            if (this.acordos.length == 0 && this.pagination.page > 1) {
                this.filtrar()
            }

            this.carregando = false
        },
        async exportar(tipoExportacao = 'acordos') {
            if (!this.$refs.filtro.validate()) return

            this.carregando = true
            const urls = {
                acordos: "/negociacaoComercial/exportar",
                produtos: "/negociacaoComercial/exportar-produtos",
            }
            const filtro = this.$refs.filtro.filtro

            const data = {}

            data.mesInicial = filtro.mesInicial
            data.mesFinal = filtro.mesFinal
            data.tipoPeriodo = filtro.tipoPeriodo ? filtro.tipoPeriodo : -1

            data.bandeira = filtro.bandeira
            data.id_espaco = filtro.id_espaco
            data.espaco_macro = filtro.espaco_macro
            data.id_fornecedor = filtro.id_fornecedor
            data.id_status = filtro.id_status ? filtro.id_status : []
            data.id_negociacao_comercial = filtro.id_negociacao_comercial
                ? [filtro.id_negociacao_comercial]
                : []
            data.acordo_rd = filtro.acordo_rd ? [filtro.acordo_rd] : []
            data.id_contrato = filtro.id_contrato ? [filtro.id_contrato] : []
            data.contrato = filtro.contrato ? [filtro.contrato] : []

            const response = await this.$http().post(
                urls[tipoExportacao],
                {
                    data: data,
                }
            )

            window.location = this.$http('baseURL') + response.data.url

            this.carregando = false
        },
        async liberarAcordo(acordos) {
            this.carregando = true

            var response = await this.$http().post(
                '/negociacaoComercial/liberarAcordo',
                {
                    data: {
                        acordos: acordos,
                    },
                }
            )

            if (response.data.sucesso) {
                this.filtrar(false)
                if (response.data.msgAlerta !== ''){
                    this.alerta = true;
                    this.alertaColor = "warning";
                    this.alertaTimeout = -1;
                    this.alertaTexto = response.data.msgAlerta;
                }
            } else {
                // this.alerta = true;
                // this.alertaColor = "error";
                // this.alertaTimeout = -1;
                // this.alertaTexto = response.data.msg;
                this.dialogErroLiberacao = true
                this.errosImportacao = response.data.erros
            }

            this.acordoSelecionado = []
            this.carregando = false
        },
        dialogoLiberarAcordos(acordo = null) {
            let acordos = acordo
                ? [acordo]
                : this.acordoSelecionado.filter((e) =>
                      this.statusAcesso(e.id_status, 'liberar')
                  )
            const total = acordos.reduce(
                (a, e) => (a += parseFloat(e.investimento) || 0),
                0
            )
            acordos = acordos.map((a) => a.id_negociacao_comercial)
            // console.log(acordos)
            this.$refs.dialogo.liberar(acordos, total)
        },
        // liberarEmMassa() {
        //     const acordos = this.acordoSelecionado
        //         .filter((e) => this.statusAcesso(e.id_status, "liberar"))
        //         .map((a) => a.id_negociacao_comercial);
        //     const investimento = this.acordoSelecionado.reduce((a,e) => a += parseFloat(e.investimento),0)
        //     // console.log(investimento)
        //     // console.log("selecionados: ", this.acordoSelecionado);
        //     // console.log("acordos: ", acordos);
        //     this.$refs.dialogo.liberar(acordos,investimento);
        // },
        renovar(data) {
            this.$refs.formulario.editar(data.item)
        },
        fecharDialogProgresso() {
            this.dialogProgresso = false
            this.progressoFinalizado = false
            this.progressoPorcentagem = 0
            this.progressoMensagem = ''
            
            // Atualizar a lista se o processo foi bem-sucedido
            if (this.progressoSucesso) {
                this.filtrar(false)
            }
        },
        async abrirPreviewGerarAcordos() {
            this.previewDados = null
            this.carregandoPreview = true
            this.dialogConfirmacaoGerarAcordos = true

            try {
                const response = await this.$http().post('/negociacaoComercial/previewAcordosAutomaticos', {})
                this.previewDados = response.data
            } catch (error) {
                this.previewDados = {
                    success: false,
                    message: 'Erro ao carregar o preview. Você ainda pode confirmar a geração.',
                    acordosPrevistos: [],
                    acordosAusentes: [],
                    fornecedoresSemNeogrupo: [],
                }
            } finally {
                this.carregandoPreview = false
            }
        },
        formatarMoedaPreview(valor) {
            if (valor === null || valor === undefined || valor === '') {
                return '—'
            }
            const numero = Number(valor)
            if (Number.isNaN(numero)) {
                return '—'
            }
            return numero.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
            })
        },
        abrirDetalhePreview(tipo) {
            const configPorTipo = {
                acordosAusentes: {
                    titulo: 'Acordos Ausentes — Fornecedores sem produtos PDV',
                    dados: this.previewDados.acordosAusentes,
                    labels: {
                        nome: 'Fornecedor',
                        codigo: 'Código',
                        bandeira: 'Bandeira',
                        neogrupo: 'Neogrupo',
                        percentual: 'Percentual (%)',
                    },
                    headers: [
                        { text: 'Fornecedor', value: 'nome' },
                        { text: 'Código', value: 'codigo' },
                        { text: 'Bandeira', value: 'bandeira' },
                        { text: 'Neogrupo', value: 'neogrupo' },
                        { text: 'Percentual (%)', value: 'percentual' },
                    ],
                    nomeArquivo: 'acordos-ausentes.csv',
                },
                fornecedoresSemNeogrupo: {
                    titulo: 'Fornecedores sem Percentuais de Neogrupo Cadastrados',
                    dados: this.previewDados.fornecedoresSemNeogrupo,
                    labels: {
                        nome: 'Fornecedor',
                        codigo: 'Código',
                        total_investimento: 'Investimento Total',
                        acordos_pdv: 'Acordos PDV',
                    },
                    headers: [
                        { text: 'Fornecedor', value: 'nome' },
                        { text: 'Código', value: 'codigo' },
                        { text: 'Investimento Total', value: 'total_investimento' },
                        { text: 'Acordos PDV', value: 'acordos_pdv' },
                    ],
                    nomeArquivo: 'fornecedores-sem-neogrupo.csv',
                },
            }

            this.previewDetalheConfig = configPorTipo[tipo]
            this.dialogPreviewDetalhe = true
        },
        confirmarGerarAcordos() {
            this.dialogConfirmacaoGerarAcordos = false
            this.gerarAcordoAutomatico()
        },
        async gerarAcordoAutomatico() {
            this.dialogProgresso = true
            this.progressoPorcentagem = 0
            this.progressoMensagem = 'Iniciando geração de acordos automáticos...'
            this.progressoFinalizado = false
            this.progressoSucesso = false
            this.progressoMensagemFinal = ''

            try {
                const response = await fetch(this.$http('baseURL') + '/negociacaoComercial/gerarAcordosAutomaticos', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.$store.getters.getToken}`,
                    },
                    body: JSON.stringify({})
                })

                const reader = response.body.getReader()
                const decoder = new TextDecoder()
                let buffer = ''
                let streaming = true

                while (streaming) {
                    const { done, value } = await reader.read()
                    
                    if (done) {
                        streaming = false
                        break
                    }
                    
                    buffer += decoder.decode(value, { stream: true })
                    
                    // Processar múltiplas linhas que podem vir no buffer
                    const lines = buffer.split('\n')
                    buffer = lines.pop() // Guardar a última linha incompleta
                    
                    for (const line of lines) {
                        if (line.trim()) {
                            try {
                                const data = JSON.parse(line)
                                
                                if (data.porcentagem !== undefined) {
                                    this.progressoPorcentagem = data.porcentagem
                                }
                                
                                if (data.mensagem) {
                                    this.progressoMensagem = data.mensagem
                                }
                                
                                // Verificar se é a mensagem final
                                if (data.success !== undefined) {
                                    this.progressoFinalizado = true
                                    this.progressoSucesso = data.success
                                    this.progressoMensagemFinal = data.message || (data.success ? 'Acordos automáticos gerados com sucesso!' : 'Erro ao gerar acordos automáticos')
                                    
                                    if (data.success) {
                                        this.progressoPorcentagem = 100
                                    }
                                }
                            } catch (e) {
                                console.error('Erro ao processar linha:', line, e)
                            }
                        }
                    }
                }
                
                // Processar qualquer dado restante no buffer
                if (buffer.trim()) {
                    try {
                        const data = JSON.parse(buffer)
                        if (data.success !== undefined) {
                            this.progressoFinalizado = true
                            this.progressoSucesso = data.success
                            this.progressoMensagemFinal = data.message || (data.success ? 'Acordos automáticos gerados com sucesso!' : 'Erro ao gerar acordos automáticos')
                            
                            if (data.success) {
                                this.progressoPorcentagem = 100
                            }
                        }
                    } catch (e) {
                        console.error('Erro ao processar buffer final:', buffer, e)
                    }
                }
                
            } catch (error) {
                this.progressoFinalizado = true
                this.progressoSucesso = false
                this.progressoMensagemFinal = 'Erro de conexão ao gerar acordos automáticos'
                console.error('Erro ao gerar acordos automáticos:', error)
            }
        },
        async aprovarAcordo(data) {
            this.carregando = true

            data.acordos = data.id_negociacao_comercial
                ? [data.id_negociacao_comercial]
                : this.acordoSelecionado
                      .filter((e) =>
                          this.statusAcesso(e.id_status, 'aprovar_reprovar')
                      )
                      .map((a) => a.id_negociacao_comercial)

            var response = await this.$http().post(
                '/negociacaoComercial/aprovarAcordo',
                {
                    data: data,
                }
            )

            if (response.data.sucesso) {
                this.filtrar(false)
                // console.log('Success')
            } else {
                this.alerta = true
                this.alertaColor = 'error'
                this.alertaTimeout = -1
                this.alertaTexto = response.data.msg
            }

            this.acordoSelecionado = []
            this.carregando = false
        },
    },
}
</script>
